import urls from '../constants/urls'
import toast from '../../components/elem/Toast'
import Toast from '../../components/elem/Toast'
import { unexpectedErrorText } from '../../utils/submissions/helperText'

const isValidFormType = formType => {
    return formType && Object.keys(formType).length
}

// upload
const create = (
    authFetch,
    API_URL,
    history,
    formType,
    agencyCode,
    username
) => {
    authFetch(`${API_URL}/upload/create`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify({
            AgencyCode: agencyCode,
            UploadUser: username,
            FormType: formType.FormType,
        }),
    })
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            const submissionId = response.submissionId
            history.push(`${(urls.form, formType.Link)}/${submissionId}`)
        })
        .catch(e => {
            Toast({
                level: 'error',
                message: unexpectedErrorText,
                autoClose: false,
                alert: true,
            })
            toast({
                level: 'error',
                message:
                    'Submission: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const approve = (
    authFetch,
    API_URL,
    history,
    uploadId,
    comments,
    username,
    after,
    formType
) => {
    try {
        const commentsParam = comments ? comments : ''
        authFetch(
            `${API_URL}/${formType.APILink}/approve?uploadId=${uploadId}&comments=${commentsParam}&user=${username}`
        )
            .then(async response => {
                if (response.ok) {
                    return response.json()
                } else {
                    const error = await response.text()
                    throw new Error(error)
                }
            })
            .then(() => {
                history.push({
                    pathname: urls.manageSampleResults,
                    state: { from: 'submitted' },
                })
            })
            .catch(e => {
                Toast({
                    level: 'error',
                    message: unexpectedErrorText,
                    autoClose: false,
                    alert: true,
                })
            })
            .finally(() => {
                after()
            })
    } catch {}
}

const reject = (
    authFetch,
    API_URL,
    history,
    uploadId,
    comments,
    username,
    after
) => {
    try {
        authFetch(
            `${API_URL}/upload/reject?uploadId=${uploadId}&comments=${comments}&user=${username}`
        )
            .then(async response => {
                if (response.ok) {
                    return response.json()
                } else {
                    const error = await response.text()
                    throw new Error(error)
                }
            })
            .then(() => {
                history.push({
                    pathname: urls.manageSampleResults,
                    state: { from: 'submitted' },
                })
            })
            .catch(e => {
                Toast({
                    level: 'error',
                    message: unexpectedErrorText,
                    autoClose: false,
                    alert: true,
                })
            })
            .finally(() => {
                after()
            })
    } catch {}
}

// submission ui
const getExistingSubmission = (
    authFetch,
    API_URL,
    uploadId,
    formType,
    after,
    loading
) => {
    loading(true)
    authFetch(`${API_URL}/${formType.APILink}/uploadData?uploadId=${uploadId}`)
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response.uploadData)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'Existing Submission Data: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
        .finally(() => loading(false))
}

const getUploadChanges = (authFetch, API_URL, uploadId, formType, after) => {
    authFetch(
        `${API_URL}/${formType.APILink}/uploadChanges?uploadId=${uploadId}`
    )
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response.uploadChanges)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'Existing Submission Data: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getSubmissionConfig = (authFetch, API_URL, formType, after) => {
    authFetch(`${API_URL}/${formType.APILink}/uploadConfig`)
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response.uploadConfig)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'Submission Config: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getReviewText = (authFetch, API_URL, uploadId, formType, after) => {
    authFetch(
        `${API_URL}/${formType.APILink}/getReviewText?uploadId=${uploadId}`
    )
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response.reviewText)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'Get Submission Review Text: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

// edd
const getEDDConfig = (authFetch, API_URL, after) => {
    authFetch(`${API_URL}/upload/eddConfig`)
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response.config)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'EDD Config:' +
                    (e.message ? e.message : 'Unable to fetch EDD config.'),
            })
        })
}

// forms in progress + submitted forms grids
const getTableData = (authFetch, API_URL, setLoading, after) => {
    setLoading(true)
    authFetch(`${API_URL}/upload`)
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'Submissions: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
        .finally(() => setLoading(false))
}

const bulkSubmit = (
    action,
    authFetch,
    API_URL,
    uploadIds,
    comments,
    username,
    onError,
    after
) => {
    authFetch(`${API_URL}/upload/bulk${action}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify({
            UploadUser: username,
            UploadIds: uploadIds,
            Comments: comments,
        }),
    })
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response)
        })
        .catch(e => {
            onError(e)
            toast({
                level: 'error',
                message:
                    'Bulk Submission: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
                alert: true,
            })
        })
}

// shared
const getAgencies = (authFetch, API_URL, after) => {
    authFetch(`${API_URL}/upload/agencies`)
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response.agencies)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'Submission Agencies: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getFormTypes = (authFetch, API_URL, after) => {
    authFetch(`${API_URL}/upload/formTypes`)
        .then(async response => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then(response => {
            after(response.formTypes)
        })
        .catch(e => {
            toast({
                level: 'error',
                message:
                    'Submission Form Types: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const out = {
    reject,
    approve,
    create,
    getExistingSubmission,
    getUploadChanges,
    bulkSubmit,
    getAgencies,
    getSubmissionConfig,
    getEDDConfig,
    getTableData,
    getReviewText,
    isValidFormType,
    getFormTypes,
}

export default out
